import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  apiSetStore: (bvModal, params, sections, callback) => {
    return AppModel.get('estimate/other', bvModal, params, (res) => {
      if (isDebug) {
        console.log(res.data)
      }

      AppModel.validateStatus(res.data)

      let modelStore = store.getters.model
      for (const section of sections) {
        if (!modelStore['otherEstimate']) {
          modelStore['otherEstimate'] = {'imageAndMemo': {}}
        }
        if (!(section in modelStore['otherEstimate']['imageAndMemo'])) {
          // 連想配列の順番を固定化するため、キー値を指定して初期化する。
          modelStore['otherEstimate']['imageAndMemo'][section] = {}
        }
      }
      const tables = Object.keys(res.data)
      for (const table of tables) {
        if (table !== 'status' && table !== 'message' && table !== 'notOverSizeFlag' && table !== 'startNo' && table !== 'functionStartNo' && table !== '変更履歴') {
          if (modelStore['otherEstimate']['imageAndMemo'][table]['images']) {
            for (const i in res.data[table]['images']) {
              modelStore['otherEstimate']['imageAndMemo'][table]['images'].push(res.data[table]['images'][i])
            }
            modelStore['otherEstimate']['imageAndMemo'][table]['memo'] = res.data[table]['memo']
          } else {
            modelStore['otherEstimate']['imageAndMemo'][table] = res.data[table]
          }
        }
        if (table === '変更履歴') {
          if (modelStore['otherEstimate']['imageAndMemo'][table]['changeHistoryInfo']) {
            for (const i in res.data[table]['changeHistoryInfo']) {
              let onlyImage = false
              for (const t in modelStore['otherEstimate']['imageAndMemo'][table]['changeHistoryInfo']) {
                if (res.data[table]['changeHistoryInfo'][i]['startNo'] === modelStore['otherEstimate']['imageAndMemo'][table]['changeHistoryInfo'][t]['startNo']) {
                  for (const s in res.data[table]['changeHistoryInfo'][i]['images']) {
                    modelStore['otherEstimate']['imageAndMemo'][table]['changeHistoryInfo'][t]['images'].push(res.data[table]['changeHistoryInfo'][i]['images'][s])
                  }
                  onlyImage = true
                  break
                }
              }
              if (onlyImage === false) {
                modelStore['otherEstimate']['imageAndMemo'][table]['changeHistoryInfo'].push(res.data[table]['changeHistoryInfo'][i])
              }
            }
          } else {
            modelStore['otherEstimate']['imageAndMemo'][table]['changeHistoryInfo'] = res.data[table]['changeHistoryInfo']
          }
        }
      }
      store.commit('setModel', modelStore)
      console.log(modelStore['otherEstimate'])
      return Promise.resolve(res.data)
    }, null, callback)
  },
  getStore: (key) => {
    return AppModel.getStore('otherEstimate', key)
  },
  removeStore: () => {
    delete store.getters.model.estimate
  }
}
